/**
 * Shared PII masking helpers.
 *
 * @graph-stack cortex-observability
 * @graph-domain Engineering
 * @graph-business 複数 app の観測ログ・外部APIレスポンス匿名化で同じ email マスク規則を共有し、PII を残さず調査に必要な domain 構造だけを保持する
 * @graph-connects none
 */
/**
 * Mask an email address as `a***@example.com`.
 *
 * @param value Potential email address
 * @returns Masked email when valid, otherwise `***`
 * @graph-stack cortex-observability
 * @graph-domain Engineering
 * @graph-business email のローカル部を先頭1文字以外伏字化し、@domain は保持して一次対応時のドメイン特定と PII 保護を両立する
 * @graph-connects none
 */
export function maskEmail(value) {
    if (typeof value !== 'string')
        return '***';
    const atIndex = value.indexOf('@');
    if (atIndex <= 0)
        return '***';
    const local = value.slice(0, atIndex);
    const domain = value.slice(atIndex + 1);
    if (domain.length === 0)
        return '***';
    return `${local.slice(0, 1)}***@${domain}`;
}
//# sourceMappingURL=index.js.map